import KeyframeLogo from "components/icons/keyframe-logo-full.svg";
import ParticleCircle from "components/animations/ParticleCircle";

export default function HalfAndHalfDonutLayout(p: {
  children: React.ReactNode;
}) {
  return (
    <div className="h-screen w-screen bg-white px-0 py-8 md:p-12">
      <KeyframeLogo
        className="absolute left-4 top-4 w-44"
        aria-label="Keyframe"
      />
      <div className="flex h-full gap-10">
        <section className="flex-1 space-y-4 overflow-y-auto px-4 py-8 text-gray-800 md:w-96">
          {p.children}
        </section>

        <section className="hidden flex-1 items-center rounded-3xl bg-gray-50 xl:flex">
          <ParticleCircle />
        </section>
      </div>
    </div>
  );
}
